import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Hub } from '~app/modules/custom-hub/models';
import { API_CUSTOM_HUBPAGE_ROUTE } from '~app/modules/custom-hub/constants';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class HubService {

  constructor(private http: HttpClient) {
  }

  getCustomHubConfig(pageName: string): Observable<Hub> {
    return this.http.get<Hub>(`${API_CUSTOM_HUBPAGE_ROUTE()}/${pageName}`);
  }
}
